import { heroCards } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative pt-28 md:pt-36 pb-14 md:pb-20 overflow-hidden">
      {/* soft ambient shapes */}
      <div className="pointer-events-none absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-accent-100/60 blur-3xl" />
      <div className="pointer-events-none absolute top-40 -left-32 w-[380px] h-[380px] rounded-full bg-secondary-100/50 blur-3xl" />

      <div className="relative w-full px-4 md:px-8">
        {/* sparse heading block */}
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-100 border border-background-200 text-xs font-label text-foreground-600">
            <i className="ri-record-circle-line text-primary-500 text-sm animate-subtle-pulse"></i>
            语音内容持续整理中 · 24 小时内同步热点
          </span>

          <h1 className="mt-6 font-heading font-bold text-foreground-950 text-3xl md:text-5xl leading-[1.2] tracking-tight">
            黑料吃话语音原声
            <br className="hidden sm:block" />
            <span className="text-primary-500">听声辨人</span>
            <span className="text-foreground-950">，不放过一句关键话</span>
          </h1>

          <p className="mt-5 text-sm md:text-base font-label text-foreground-600 leading-relaxed max-w-2xl">
            把散落各处的录音原声、对话片段与长录音整理成能顺序听的入口。保留原始语气、标注关键时间点，
            方便你快速了解事件来龙去脉。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row sm:items-center gap-3">
            <a
              href="#hot"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-play-circle-line text-lg"></i>
              浏览热听原声
            </a>
            <a
              href="#categories"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm font-label hover:border-secondary-400 hover:text-secondary-700 transition-colors cursor-pointer"
            >
              <i className="ri-links-line text-lg"></i>
              按形态快速进入
            </a>
          </div>
        </div>

        {/* multi-card parallel first screen */}
        <div className="mt-12 md:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
          {heroCards.map((card, index) => (
            <a
              key={card.id}
              href="#hot"
              className="group relative rounded-lg overflow-hidden bg-foreground-900 cursor-pointer animate-fade-up"
              style={{ animationDelay: `${index * 90}ms` }}
            >
              <div className="relative w-full aspect-[4/5]">
                <img
                  src={card.cover}
                  alt={`${card.title} 黑料吃话录音封面`}
                  title={`${card.title} - 黑料吃话语音`}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/35 to-transparent"></div>

                <div className="relative h-full flex flex-col justify-between p-3 md:p-3.5">
                  <span className="self-start px-2 py-1 rounded-md bg-background-50/95 text-[11px] font-label text-primary-700 whitespace-nowrap">
                    {card.tag}
                  </span>

                  <div>
                    <span className="flex items-center gap-2 text-background-200 text-[11px] font-label">
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-headphone-line text-sm"></i>
                        {card.listens}
                      </span>
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-time-line text-sm"></i>
                        {card.duration}
                      </span>
                    </span>
                    <h3 className="mt-1.5 font-heading font-semibold text-background-50 text-sm md:text-base leading-snug line-clamp-2">
                      {card.title}
                    </h3>
                    <p className="hidden sm:block mt-1 text-[11px] font-label text-background-200/90 line-clamp-2 leading-relaxed">
                      {card.desc}
                    </p>
                    <span className="mt-2 inline-flex items-center gap-1.5 text-[11px] font-label text-accent-300 group-hover:text-accent-200">
                      <i className="ri-play-fill"></i>
                      点开收听
                    </span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}